// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- coarse-pointer flight deck ---------- */
.touch-controls {
  --touch-size: 46px;
  position: absolute;
  inset: 0;
  z-index: 20;
  display: none;
  pointer-events: none;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
}
.touch-controls.visible { display: block; }
.touch-controls button,
.touch-stick {
  pointer-events: auto;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}
.touch-controls button {
  min-width: var(--touch-size);
  min-height: var(--touch-size);
  padding: 0 8px;
  color: rgba(215, 244, 255, 0.88);
  background:
    linear-gradient(145deg, rgba(39, 232, 255, 0.14), rgba(4, 12, 20, 0.78));
  border: 1px solid rgba(39, 232, 255, 0.42);
  border-left-width: 2px;
  clip-path: polygon(7px 0, 100% 0, 100% calc(100% - 7px), calc(100% - 7px) 100%, 0 100%, 0 7px);
  box-shadow: inset 0 0 16px rgba(39, 232, 255, 0.06), 0 0 14px rgba(0, 0, 0, 0.4);
  font: 600 9px/1 var(--font);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  text-shadow: 0 0 7px rgba(39, 232, 255, 0.55);
}
.touch-controls button.active {
  color: #fff;
  border-color: var(--accent);
  background: linear-gradient(145deg, rgba(39, 232, 255, 0.46), rgba(12, 61, 74, 0.84));
  box-shadow: inset 0 0 18px rgba(39, 232, 255, 0.25), 0 0 20px rgba(39, 232, 255, 0.45);
  transform: scale(0.96);
}

.touch-stick {
  position: absolute;
  width: 134px;
  height: 134px;
  border: 1px solid rgba(39, 232, 255, 0.34);
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(39, 232, 255, 0.08) 0 30%, transparent 31%),
    repeating-radial-gradient(circle, transparent 0 27px, rgba(39, 232, 255, 0.1) 28px 29px);
  box-shadow: inset 0 0 30px rgba(39, 232, 255, 0.06), 0 0 18px rgba(0, 0, 0, 0.55);
}
.touch-stick::before,
.touch-stick::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  background: rgba(39, 232, 255, 0.2);
  transform: translate(-50%, -50%);
}
.touch-stick::before { width: 78%; height: 1px; }
.touch-stick::after { width: 1px; height: 78%; }
.touch-stick-rings {
  position: absolute;
  inset: 11px;
  border: 1px dashed rgba(39, 232, 255, 0.2);
  border-radius: 50%;
}
.touch-stick-knob {
  --stick-x: 0px;
  --stick-y: 0px;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(159, 240, 255, 0.8);
  border-radius: 50%;
  background: radial-gradient(circle at 38% 32%, rgba(180, 250, 255, 0.46), rgba(11, 69, 82, 0.82));
  box-shadow: inset 0 0 15px rgba(39, 232, 255, 0.32), 0 0 16px rgba(39, 232, 255, 0.42);
  transform: translate(calc(-50% + var(--stick-x)), calc(-50% + var(--stick-y)));
}
.touch-stick > span {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  color: rgba(159, 240, 255, 0.56);
  font: 600 8px/1 var(--font);
  letter-spacing: 0.32em;
  text-indent: 0.32em;
  text-transform: uppercase;
}
.touch-stick.active { border-color: rgba(39, 232, 255, 0.85); }

.touch-left-deck {
  position: absolute;
  left: max(12px, env(safe-area-inset-left));
  bottom: max(10px, env(safe-area-inset-bottom));
  width: 290px;
  height: 164px;
}
.touch-move-stick { left: 0; bottom: 0; }
.touch-maneuver {
  position: absolute;
  left: 140px;
  top: 0;
  display: grid;
  grid-template-columns: repeat(2, 58px);
  gap: 5px;
}
.touch-maneuver button { min-height: 46px; }
.touch-boost {
  position: absolute;
  left: 140px;
  bottom: 0;
  width: 121px;
  height: 58px;
  color: #e7c9ff !important;
  border-color: rgba(194, 106, 255, 0.68) !important;
  background: linear-gradient(145deg, rgba(194, 106, 255, 0.24), rgba(26, 10, 41, 0.84)) !important;
}

.touch-right-deck {
  position: absolute;
  right: max(12px, env(safe-area-inset-right));
  bottom: max(10px, env(safe-area-inset-bottom));
  width: 320px;
  height: 164px;
}
.touch-aim-stick { left: 0; bottom: 0; }
.touch-actions { position: absolute; inset: 0 0 0 142px; }
.touch-actions button { position: absolute; }
.touch-fire {
  right: 0;
  bottom: 64px;
  width: 78px;
  height: 78px;
  color: #fff4dc !important;
  border-color: rgba(255, 179, 71, 0.82) !important;
  background: radial-gradient(circle, rgba(255, 179, 71, 0.34), rgba(55, 25, 5, 0.86)) !important;
  border-radius: 50%;
  clip-path: none !important;
}
.touch-seeker {
  right: 84px;
  bottom: 95px;
  width: 58px;
  height: 58px;
  color: #ffcf92 !important;
  border-color: rgba(255, 179, 71, 0.6) !important;
}
.touch-actions [data-touch-action='weapon'] { right: 84px; bottom: 48px; width: 66px; }
.touch-actions [data-touch-action='interact'] { right: 6px; bottom: 8px; width: 72px; }
.touch-actions [data-touch-action='decline'] { right: 84px; bottom: 0; min-width: 48px; }

.touch-system-tray {
  position: absolute;
  left: 46.5%;
  bottom: max(8px, env(safe-area-inset-bottom));
  display: flex;
  gap: 4px;
  transform: translateX(-50%);
}
.touch-system-tray button { width: 46px; padding: 0 3px; }
.touch-system-tray .touch-jump {
  width: 52px;
  color: #a8fff1;
  border-color: rgba(46, 230, 200, 0.62);
}
.touch-utility {
  position: absolute;
  right: max(10px, env(safe-area-inset-right));
  top: max(9px, env(safe-area-inset-top));
  display: flex;
  gap: 5px;
}
.touch-utility button { min-height: 46px; }

html.touch-layout,
html.touch-layout body,
html.touch-layout #game-canvas,
html.touch-layout #ui-root { touch-action: none; }
html.touch-layout .hud-hint { display: none; }
html.touch-layout .hud-vitals { left: 16px; bottom: 194px; }
html.touch-layout .hud-drive { left: 238px; bottom: 194px; }
html.touch-layout .hud-kit { bottom: 190px; }
html.touch-layout .hud-weapons { right: 16px; bottom: 194px; }
html.touch-layout .radar-wrap { right: 272px; bottom: 178px; }
html.touch-layout .hud-resources { right: 18px; bottom: 345px; }
html.touch-layout .interact-prompt { bottom: 362px; }

/* Every pre-flight and overlay screen must remain operable without a mouse. */
html.touch-layout .screen {
  overflow-y: auto;
  padding: 14px;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}
html.touch-layout .ns-btn { min-height: 50px; }
html.touch-layout .close-x { width: 46px; height: 46px; }
html.touch-layout .manual-panel,
html.touch-layout .controls-panel { max-width: 96vw; max-height: 84vh; overflow-y: auto; }
html.touch-layout .loadout-panel { width: min(94vw, 860px); max-height: 84vh; }

/* On touch, keep the hangar as native, scrollable DOM instead of a rasterized
   visor. This preserves direct card/button semantics and reliable hit targets. */
html.touch-layout .screen.hangar {
  align-items: stretch;
  overflow-y: auto;
  padding: 10px 12px;
  /* #ui-root is pointer-transparent during flight. Restore hit testing at
     the scroll container so a swipe may begin on non-button hangar content,
     including the selected hull description and its hardpoint chips. */
  pointer-events: auto;
}
html.touch-layout .screen.hangar > h2 { align-self: center; margin-bottom: 14px; }
html.touch-layout .hangar-body {
  display: block;
  width: 100%;
  min-height: max-content;
  flex: none;
  padding: 8px 2px 80px;
  overflow: visible;
}
html.touch-layout .hangar-center,
html.touch-layout .hangar-stats { display: none; }
html.touch-layout .hangar-ships {
  width: 100%;
  overflow-x: auto;
  gap: 9px;
  padding: 3px 2px 10px;
  scroll-snap-type: x mandatory;
}
html.touch-layout .hangar-ships .ship-card {
  flex: 0 0 min(64vw, 240px);
  max-width: 240px;
  scroll-snap-align: center;
}
html.touch-layout .hangar-right { width: 100%; margin-top: 10px; }
html.touch-layout .hangar-actions {
  position: sticky;
  right: auto;
  bottom: 0;
  width: 100%;
  margin-top: 10px;
  padding: 8px 0 max(6px, env(safe-area-inset-bottom));
  background: linear-gradient(transparent, rgba(0, 5, 10, 0.94) 28%);
  z-index: 3;
}

@media (max-height: 560px) {
  html.touch-layout .hud-fps,
  html.touch-layout .hud-kit,
  html.touch-layout .hud-resources,
  html.touch-layout .radar-wrap,
  html.touch-layout .target-preview { display: none !important; }
  html.touch-layout .hud-score {
    left: 8px; top: 8px;
    padding: 7px 10px;
    transform: scale(0.8);
    transform-origin: top left;
  }
  html.touch-layout .hud-vitals { left: 8px; top: 69px; bottom: auto; width: 145px; }
  html.touch-layout .hud-drive { left: 163px; top: 69px; bottom: auto; width: 145px; }
  html.touch-layout .hud-weapons {
    right: 8px; top: 57px; bottom: auto;
    width: 174px; padding: 7px 10px;
  }
  html.touch-layout .hud-weapons .panel-title { display: none; }
  html.touch-layout .weapon-name { font-size: 11px; }
  html.touch-layout .comms-feed {
    left: 242px; top: 8px; width: min(310px, 38vw);
  }
  html.touch-layout .comms-line { padding: 5px 8px; font-size: 10px; }
  html.touch-layout .interact-prompt {
    bottom: 174px;
    max-width: 42vw;
    padding: 5px 10px;
    font-size: 10px;
    letter-spacing: 0.18em;
  }
  html.touch-layout .offer-panel { right: 10px; top: 116px; width: 280px; padding: 10px 12px; }
  html.touch-layout .wave-banner { top: 18%; font-size: 20px; }
  html.touch-layout .screen { justify-content: flex-start; }
  html.touch-layout .title { margin-top: 5vh; font-size: clamp(31px, 9vw, 54px); }
  html.touch-layout .subtitle { margin: 8px 0 20px; font-size: 10px; }
  html.touch-layout .controls-cols,
  html.touch-layout .manual-cols { flex-direction: column; gap: 12px; }
  html.touch-layout .loadout-panel {
    height: 84vh;
    flex-direction: row;
    gap: 12px;
    overflow: hidden;
  }
  html.touch-layout .loadout-left {
    width: 35%;
    flex-shrink: 0;
    overflow-y: auto;
  }
  html.touch-layout .loadout-right { min-width: 0; overflow-y: auto; }
  html.touch-layout .recipe-row { padding: 8px; }
  html.touch-layout .trade-panel { height: 84vh; width: 94vw; }
  html.touch-layout .screen.hangar > h2 { min-width: 280px; font-size: 21px; }
  html.touch-layout .hangar-body { padding-bottom: 4px; }
  html.touch-layout .hangar-main { display: block; }
  html.touch-layout .hangar-ships { overflow: visible; padding-bottom: 4px; }
  html.touch-layout .hangar-ships .ship-card {
    flex: 1 1 0;
    max-width: none;
    padding-bottom: 7px;
  }
  html.touch-layout .ship-thumb { height: 70px; }
  html.touch-layout .hangar-ships .stat-row { display: none; }
  html.touch-layout .hangar-right {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    margin-top: 4px;
  }
  html.touch-layout .hangar-right .ship-detail { display: none; }
  html.touch-layout .hangar-right > .hangar-subhead { grid-column: 1 / -1; }
  html.touch-layout .diff-btn {
    min-height: 54px;
    padding: 6px 8px;
    gap: 7px;
    align-items: center;
  }
  html.touch-layout .diff-icon { width: 24px; height: 24px; }
  html.touch-layout .diff-btn b { margin: 0; font-size: 12px; }
  html.touch-layout .diff-btn .diff-text > span { display: none; }
  html.touch-layout .hangar-actions {
    position: static;
    margin-top: 7px;
    padding: 0;
    background: none;
  }
  html.touch-layout .hangar-actions .ns-btn { min-height: 46px; padding-block: 8px; }
}

@media (orientation: portrait) {
  .touch-controls { --touch-size: 44px; }
  .touch-stick { width: 104px; height: 104px; }
  .touch-stick-knob { width: 44px; height: 44px; }
  .touch-left-deck,
  .touch-right-deck {
    bottom: max(8px, env(safe-area-inset-bottom));
    width: 104px;
    height: 158px;
  }
  .touch-left-deck { left: max(8px, env(safe-area-inset-left)); }
  .touch-right-deck { right: max(8px, env(safe-area-inset-right)); }
  .touch-move-stick,
  .touch-aim-stick { left: 0; bottom: 0; }
  .touch-maneuver {
    position: fixed;
    left: 50%;
    top: auto;
    bottom: max(8px, env(safe-area-inset-bottom));
    grid-template-columns: repeat(2, 52px);
    gap: 4px;
    transform: translateX(-50%);
  }
  .touch-maneuver button { min-width: 52px; min-height: 48px; padding: 0 3px; }
  .touch-boost {
    left: 0;
    bottom: 112px;
    width: 104px;
    height: 46px;
  }
  .touch-actions {
    position: fixed;
    left: max(120px, calc(env(safe-area-inset-left) + 120px));
    right: max(8px, env(safe-area-inset-right));
    top: auto;
    bottom: max(120px, calc(env(safe-area-inset-bottom) + 120px));
    display: flex;
    gap: 3px;
    transform: none;
  }
  .touch-actions button,
  .touch-fire,
  .touch-seeker,
  .touch-actions [data-touch-action='weapon'],
  .touch-actions [data-touch-action='interact'],
  .touch-actions [data-touch-action='decline'] {
    position: static;
    flex: 1 1 0;
    width: auto;
    min-width: 44px;
    height: 46px;
    min-height: 46px;
    padding: 0 2px;
    border-radius: 0;
    clip-path: polygon(7px 0, 100% 0, 100% calc(100% - 7px), calc(100% - 7px) 100%, 0 100%, 0 7px) !important;
  }
  .touch-system-tray {
    left: 50%;
    bottom: max(172px, calc(env(safe-area-inset-bottom) + 172px));
    transform: translateX(-50%);
  }
  .touch-system-tray button { width: 48px; }
  .touch-utility {
    left: 50%;
    right: auto;
    top: auto;
    bottom: max(224px, calc(env(safe-area-inset-bottom) + 224px));
    transform: translateX(-50%);
  }
  .touch-utility button { width: 56px; padding: 0 3px; }

  html.touch-layout .hud-vitals,
  html.touch-layout .hud-drive,
  html.touch-layout .hud-kit,
  html.touch-layout .hud-resources,
  html.touch-layout .hud-fps,
  html.touch-layout .target-preview,
  html.touch-layout .comms-feed { display: none !important; }
  html.touch-layout .hud-score {
    left: max(7px, env(safe-area-inset-left));
    top: max(7px, env(safe-area-inset-top));
    max-width: 225px;
    padding: 6px 9px;
  }
  html.touch-layout .hud-score .score-line {
    overflow: hidden;
    font-size: 9px;
    letter-spacing: 0.18em;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  html.touch-layout .hud-score .quest-tracker { display: none; }
  html.touch-layout .hud-weapons {
    right: max(7px, env(safe-area-inset-right));
    top: max(65px, calc(env(safe-area-inset-top) + 65px));
    bottom: auto;
    width: 138px;
    padding: 6px 8px;
  }
  html.touch-layout .hud-weapons .panel-title { display: none; }
  html.touch-layout .weapon-name { font-size: 10px; letter-spacing: 0.18em; }
  html.touch-layout .weapon-row { gap: 6px; margin: 4px 0; }
  html.touch-layout .weapon-slot { width: 23px; height: 18px; line-height: 18px; }
  html.touch-layout .missile-status { font-size: 8px; letter-spacing: 0.15em; }
  html.touch-layout .radar-wrap {
    left: max(7px, env(safe-area-inset-left));
    right: auto;
    top: max(65px, calc(env(safe-area-inset-top) + 65px));
    bottom: auto;
    width: 82px;
    height: 82px;
    opacity: 0.72;
  }
  html.touch-layout .radar-wrap .radar-canvas {
    width: 100% !important;
    height: 100% !important;
  }
  html.touch-layout .interact-prompt { bottom: 286px; max-width: 72vw; }

  html.touch-layout .screen.hangar {
    display: block;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: max(18px, env(safe-area-inset-bottom));
  }
  html.touch-layout .screen.hangar > h2 { min-width: 0; width: 100%; }
  html.touch-layout .hangar-body { padding-bottom: 16px; }
  html.touch-layout .hangar-actions {
    position: static;
    margin-top: 14px;
    padding: 0 0 max(10px, env(safe-area-inset-bottom));
    background: none;
  }
  html.touch-layout .loadout-panel {
    height: auto;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
  }
  html.touch-layout .loadout-left { width: 100%; overflow: visible; }
  html.touch-layout .loadout-right { overflow: visible; }
}

@media (orientation: portrait) and (max-width: 340px) {
  .touch-actions {
    bottom: max(120px, calc(env(safe-area-inset-bottom) + 120px));
    display: grid;
    grid-template-columns: repeat(3, minmax(44px, 1fr));
  }
  .touch-system-tray { bottom: max(220px, calc(env(safe-area-inset-bottom) + 220px)); }
  .touch-utility { bottom: max(272px, calc(env(safe-area-inset-bottom) + 272px)); }
}
`, "",{"version":3,"sources":["webpack://./src/ui/styles/mobile-controls.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,0BAA0B,cAAc,EAAE;AAC1C;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;EACd,gCAAgC;EAChC;4EAC0E;EAC1E,0CAA0C;EAC1C,sBAAsB;EACtB,8FAA8F;EAC9F,gFAAgF;EAChF,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,qFAAqF;EACrF,sFAAsF;EACtF,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB;;4FAE0F;EAC1F,iFAAiF;AACnF;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,gCAAgC;AAClC;AACA,uBAAuB,UAAU,EAAE,WAAW,EAAE;AAChD,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C;EACE,kBAAkB;EAClB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iGAAiG;EACjG,sFAAsF;EACtF,8EAA8E;AAChF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,sBAAsB,sCAAsC,EAAE;;AAE9D;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;EAC9C,YAAY;EACZ,aAAa;AACf;AACA,oBAAoB,OAAO,EAAE,SAAS,EAAE;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,aAAa;EACb,sCAAsC;EACtC,QAAQ;AACV;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kDAAkD;EAClD,iGAAiG;AACnG;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,8CAA8C;EAC9C,YAAY;EACZ,aAAa;AACf;AACA,mBAAmB,OAAO,EAAE,SAAS,EAAE;AACvC,iBAAiB,kBAAkB,EAAE,kBAAkB,EAAE;AACzD,wBAAwB,kBAAkB,EAAE;AAC5C;EACE,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iDAAiD;EACjD,+FAA+F;EAC/F,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gDAAgD;AAClD;AACA,8CAA8C,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE;AACtF,gDAAgD,UAAU,EAAE,WAAW,EAAE,WAAW,EAAE;AACtF,+CAA+C,WAAW,EAAE,SAAS,EAAE,eAAe,EAAE;;AAExF;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,aAAa;EACb,QAAQ;EACR,2BAA2B;AAC7B;AACA,4BAA4B,WAAW,EAAE,cAAc,EAAE;AACzD;EACE,WAAW;EACX,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,uCAAuC;EACvC,aAAa;EACb,QAAQ;AACV;AACA,wBAAwB,gBAAgB,EAAE;;AAE1C;;;6BAG6B,kBAAkB,EAAE;AACjD,8BAA8B,aAAa,EAAE;AAC7C,gCAAgC,UAAU,EAAE,aAAa,EAAE;AAC3D,+BAA+B,WAAW,EAAE,aAAa,EAAE;AAC3D,6BAA6B,aAAa,EAAE;AAC5C,iCAAiC,WAAW,EAAE,aAAa,EAAE;AAC7D,gCAAgC,YAAY,EAAE,aAAa,EAAE;AAC7D,mCAAmC,WAAW,EAAE,aAAa,EAAE;AAC/D,qCAAqC,aAAa,EAAE;;AAEpD,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;AACA,4BAA4B,gBAAgB,EAAE;AAC9C,6BAA6B,WAAW,EAAE,YAAY,EAAE;AACxD;oCACoC,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACzF,mCAAmC,uBAAuB,EAAE,gBAAgB,EAAE;;AAE9E;iFACiF;AACjF;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB;;uEAEqE;EACrE,oBAAoB;AACtB;AACA,wCAAwC,kBAAkB,EAAE,mBAAmB,EAAE;AACjF;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;AACA;kCACkC,aAAa,EAAE;AACjD;EACE,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,kCAAkC,WAAW,EAAE,gBAAgB,EAAE;AACjE;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oDAAoD;EACpD,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE;;;;sCAIoC,wBAAwB,EAAE;EAC9D;IACE,SAAS,EAAE,QAAQ;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;EAC5B;EACA,gCAAgC,SAAS,EAAE,SAAS,EAAE,YAAY,EAAE,YAAY,EAAE;EAClF,+BAA+B,WAAW,EAAE,SAAS,EAAE,YAAY,EAAE,YAAY,EAAE;EACnF;IACE,UAAU,EAAE,SAAS,EAAE,YAAY;IACnC,YAAY,EAAE,iBAAiB;EACjC;EACA,8CAA8C,aAAa,EAAE;EAC7D,iCAAiC,eAAe,EAAE;EAClD;IACE,WAAW,EAAE,QAAQ,EAAE,uBAAuB;EAChD;EACA,gCAAgC,gBAAgB,EAAE,eAAe,EAAE;EACnE;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sBAAsB;EACxB;EACA,iCAAiC,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE,kBAAkB,EAAE;EAC5F,iCAAiC,QAAQ,EAAE,eAAe,EAAE;EAC5D,4BAA4B,2BAA2B,EAAE;EACzD,2BAA2B,eAAe,EAAE,iCAAiC,EAAE;EAC/E,8BAA8B,kBAAkB,EAAE,eAAe,EAAE;EACnE;mCACiC,sBAAsB,EAAE,SAAS,EAAE;EACpE;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;EACA,mCAAmC,YAAY,EAAE,gBAAgB,EAAE;EACnE,gCAAgC,YAAY,EAAE;EAC9C,iCAAiC,YAAY,EAAE,WAAW,EAAE;EAC5D,wCAAwC,gBAAgB,EAAE,eAAe,EAAE;EAC3E,iCAAiC,mBAAmB,EAAE;EACtD,iCAAiC,cAAc,EAAE;EACjD,kCAAkC,iBAAiB,EAAE,mBAAmB,EAAE;EAC1E;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;EACA,gCAAgC,YAAY,EAAE;EAC9C,4CAA4C,aAAa,EAAE;EAC3D;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,eAAe;EACjB;EACA,+CAA+C,aAAa,EAAE;EAC9D,oDAAoD,mBAAmB,EAAE;EACzE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;EACrB;EACA,+BAA+B,WAAW,EAAE,YAAY,EAAE;EAC1D,gCAAgC,SAAS,EAAE,eAAe,EAAE;EAC5D,gDAAgD,aAAa,EAAE;EAC/D;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,gBAAgB;EAClB;EACA,4CAA4C,gBAAgB,EAAE,kBAAkB,EAAE;AACpF;;AAEA;EACE,kBAAkB,kBAAkB,EAAE;EACtC,eAAe,YAAY,EAAE,aAAa,EAAE;EAC5C,oBAAoB,WAAW,EAAE,YAAY,EAAE;EAC/C;;IAEE,6CAA6C;IAC7C,YAAY;IACZ,aAAa;EACf;EACA,mBAAmB,yCAAyC,EAAE;EAC9D,oBAAoB,2CAA2C,EAAE;EACjE;qBACmB,OAAO,EAAE,SAAS,EAAE;EACvC;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,6CAA6C;IAC7C,sCAAsC;IACtC,QAAQ;IACR,2BAA2B;EAC7B;EACA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;EAC5E;IACE,OAAO;IACP,aAAa;IACb,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;IACf,yDAAyD;IACzD,2CAA2C;IAC3C,SAAS;IACT,6DAA6D;IAC7D,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;EACA;;;;;;IAME,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yGAAyG;EAC3G;EACA;IACE,SAAS;IACT,6DAA6D;IAC7D,2BAA2B;EAC7B;EACA,4BAA4B,WAAW,EAAE;EACzC;IACE,SAAS;IACT,WAAW;IACX,SAAS;IACT,6DAA6D;IAC7D,2BAA2B;EAC7B;EACA,wBAAwB,WAAW,EAAE,cAAc,EAAE;;EAErD;;;;;;kCAMgC,wBAAwB,EAAE;EAC1D;IACE,yCAAyC;IACzC,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA,8CAA8C,aAAa,EAAE;EAC7D;IACE,2CAA2C;IAC3C,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;EACA,8CAA8C,aAAa,EAAE;EAC7D,iCAAiC,eAAe,EAAE,sBAAsB,EAAE;EAC1E,gCAAgC,QAAQ,EAAE,aAAa,EAAE;EACzD,iCAAiC,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EAC/E,oCAAoC,cAAc,EAAE,sBAAsB,EAAE;EAC5E;IACE,yCAAyC;IACzC,WAAW;IACX,qDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA,qCAAqC,aAAa,EAAE,eAAe,EAAE;;EAErE;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,sDAAsD;EACxD;EACA,wCAAwC,YAAY,EAAE,WAAW,EAAE;EACnE,iCAAiC,oBAAoB,EAAE;EACvD;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mDAAmD;IACnD,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;EACA,kCAAkC,WAAW,EAAE,iBAAiB,EAAE;EAClE,mCAAmC,iBAAiB,EAAE;AACxD;;AAEA;EACE;IACE,6DAA6D;IAC7D,aAAa;IACb,mDAAmD;EACrD;EACA,qBAAqB,6DAA6D,EAAE;EACpF,iBAAiB,6DAA6D,EAAE;AAClF","sourcesContent":["/* ---------- coarse-pointer flight deck ---------- */\n.touch-controls {\n  --touch-size: 46px;\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: none;\n  pointer-events: none;\n  touch-action: none;\n  -webkit-tap-highlight-color: transparent;\n}\n.touch-controls.visible { display: block; }\n.touch-controls button,\n.touch-stick {\n  pointer-events: auto;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.touch-controls button {\n  min-width: var(--touch-size);\n  min-height: var(--touch-size);\n  padding: 0 8px;\n  color: rgba(215, 244, 255, 0.88);\n  background:\n    linear-gradient(145deg, rgba(39, 232, 255, 0.14), rgba(4, 12, 20, 0.78));\n  border: 1px solid rgba(39, 232, 255, 0.42);\n  border-left-width: 2px;\n  clip-path: polygon(7px 0, 100% 0, 100% calc(100% - 7px), calc(100% - 7px) 100%, 0 100%, 0 7px);\n  box-shadow: inset 0 0 16px rgba(39, 232, 255, 0.06), 0 0 14px rgba(0, 0, 0, 0.4);\n  font: 600 9px/1 var(--font);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  text-shadow: 0 0 7px rgba(39, 232, 255, 0.55);\n}\n.touch-controls button.active {\n  color: #fff;\n  border-color: var(--accent);\n  background: linear-gradient(145deg, rgba(39, 232, 255, 0.46), rgba(12, 61, 74, 0.84));\n  box-shadow: inset 0 0 18px rgba(39, 232, 255, 0.25), 0 0 20px rgba(39, 232, 255, 0.45);\n  transform: scale(0.96);\n}\n\n.touch-stick {\n  position: absolute;\n  width: 134px;\n  height: 134px;\n  border: 1px solid rgba(39, 232, 255, 0.34);\n  border-radius: 50%;\n  background:\n    radial-gradient(circle, rgba(39, 232, 255, 0.08) 0 30%, transparent 31%),\n    repeating-radial-gradient(circle, transparent 0 27px, rgba(39, 232, 255, 0.1) 28px 29px);\n  box-shadow: inset 0 0 30px rgba(39, 232, 255, 0.06), 0 0 18px rgba(0, 0, 0, 0.55);\n}\n.touch-stick::before,\n.touch-stick::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  background: rgba(39, 232, 255, 0.2);\n  transform: translate(-50%, -50%);\n}\n.touch-stick::before { width: 78%; height: 1px; }\n.touch-stick::after { width: 1px; height: 78%; }\n.touch-stick-rings {\n  position: absolute;\n  inset: 11px;\n  border: 1px dashed rgba(39, 232, 255, 0.2);\n  border-radius: 50%;\n}\n.touch-stick-knob {\n  --stick-x: 0px;\n  --stick-y: 0px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 48px;\n  height: 48px;\n  border: 1px solid rgba(159, 240, 255, 0.8);\n  border-radius: 50%;\n  background: radial-gradient(circle at 38% 32%, rgba(180, 250, 255, 0.46), rgba(11, 69, 82, 0.82));\n  box-shadow: inset 0 0 15px rgba(39, 232, 255, 0.32), 0 0 16px rgba(39, 232, 255, 0.42);\n  transform: translate(calc(-50% + var(--stick-x)), calc(-50% + var(--stick-y)));\n}\n.touch-stick > span {\n  position: absolute;\n  left: 50%;\n  bottom: 10px;\n  transform: translateX(-50%);\n  color: rgba(159, 240, 255, 0.56);\n  font: 600 8px/1 var(--font);\n  letter-spacing: 0.32em;\n  text-indent: 0.32em;\n  text-transform: uppercase;\n}\n.touch-stick.active { border-color: rgba(39, 232, 255, 0.85); }\n\n.touch-left-deck {\n  position: absolute;\n  left: max(12px, env(safe-area-inset-left));\n  bottom: max(10px, env(safe-area-inset-bottom));\n  width: 290px;\n  height: 164px;\n}\n.touch-move-stick { left: 0; bottom: 0; }\n.touch-maneuver {\n  position: absolute;\n  left: 140px;\n  top: 0;\n  display: grid;\n  grid-template-columns: repeat(2, 58px);\n  gap: 5px;\n}\n.touch-maneuver button { min-height: 46px; }\n.touch-boost {\n  position: absolute;\n  left: 140px;\n  bottom: 0;\n  width: 121px;\n  height: 58px;\n  color: #e7c9ff !important;\n  border-color: rgba(194, 106, 255, 0.68) !important;\n  background: linear-gradient(145deg, rgba(194, 106, 255, 0.24), rgba(26, 10, 41, 0.84)) !important;\n}\n\n.touch-right-deck {\n  position: absolute;\n  right: max(12px, env(safe-area-inset-right));\n  bottom: max(10px, env(safe-area-inset-bottom));\n  width: 320px;\n  height: 164px;\n}\n.touch-aim-stick { left: 0; bottom: 0; }\n.touch-actions { position: absolute; inset: 0 0 0 142px; }\n.touch-actions button { position: absolute; }\n.touch-fire {\n  right: 0;\n  bottom: 64px;\n  width: 78px;\n  height: 78px;\n  color: #fff4dc !important;\n  border-color: rgba(255, 179, 71, 0.82) !important;\n  background: radial-gradient(circle, rgba(255, 179, 71, 0.34), rgba(55, 25, 5, 0.86)) !important;\n  border-radius: 50%;\n  clip-path: none !important;\n}\n.touch-seeker {\n  right: 84px;\n  bottom: 95px;\n  width: 58px;\n  height: 58px;\n  color: #ffcf92 !important;\n  border-color: rgba(255, 179, 71, 0.6) !important;\n}\n.touch-actions [data-touch-action='weapon'] { right: 84px; bottom: 48px; width: 66px; }\n.touch-actions [data-touch-action='interact'] { right: 6px; bottom: 8px; width: 72px; }\n.touch-actions [data-touch-action='decline'] { right: 84px; bottom: 0; min-width: 48px; }\n\n.touch-system-tray {\n  position: absolute;\n  left: 46.5%;\n  bottom: max(8px, env(safe-area-inset-bottom));\n  display: flex;\n  gap: 4px;\n  transform: translateX(-50%);\n}\n.touch-system-tray button { width: 46px; padding: 0 3px; }\n.touch-system-tray .touch-jump {\n  width: 52px;\n  color: #a8fff1;\n  border-color: rgba(46, 230, 200, 0.62);\n}\n.touch-utility {\n  position: absolute;\n  right: max(10px, env(safe-area-inset-right));\n  top: max(9px, env(safe-area-inset-top));\n  display: flex;\n  gap: 5px;\n}\n.touch-utility button { min-height: 46px; }\n\nhtml.touch-layout,\nhtml.touch-layout body,\nhtml.touch-layout #game-canvas,\nhtml.touch-layout #ui-root { touch-action: none; }\nhtml.touch-layout .hud-hint { display: none; }\nhtml.touch-layout .hud-vitals { left: 16px; bottom: 194px; }\nhtml.touch-layout .hud-drive { left: 238px; bottom: 194px; }\nhtml.touch-layout .hud-kit { bottom: 190px; }\nhtml.touch-layout .hud-weapons { right: 16px; bottom: 194px; }\nhtml.touch-layout .radar-wrap { right: 272px; bottom: 178px; }\nhtml.touch-layout .hud-resources { right: 18px; bottom: 345px; }\nhtml.touch-layout .interact-prompt { bottom: 362px; }\n\n/* Every pre-flight and overlay screen must remain operable without a mouse. */\nhtml.touch-layout .screen {\n  overflow-y: auto;\n  padding: 14px;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n}\nhtml.touch-layout .ns-btn { min-height: 50px; }\nhtml.touch-layout .close-x { width: 46px; height: 46px; }\nhtml.touch-layout .manual-panel,\nhtml.touch-layout .controls-panel { max-width: 96vw; max-height: 84vh; overflow-y: auto; }\nhtml.touch-layout .loadout-panel { width: min(94vw, 860px); max-height: 84vh; }\n\n/* On touch, keep the hangar as native, scrollable DOM instead of a rasterized\n   visor. This preserves direct card/button semantics and reliable hit targets. */\nhtml.touch-layout .screen.hangar {\n  align-items: stretch;\n  overflow-y: auto;\n  padding: 10px 12px;\n  /* #ui-root is pointer-transparent during flight. Restore hit testing at\n     the scroll container so a swipe may begin on non-button hangar content,\n     including the selected hull description and its hardpoint chips. */\n  pointer-events: auto;\n}\nhtml.touch-layout .screen.hangar > h2 { align-self: center; margin-bottom: 14px; }\nhtml.touch-layout .hangar-body {\n  display: block;\n  width: 100%;\n  min-height: max-content;\n  flex: none;\n  padding: 8px 2px 80px;\n  overflow: visible;\n}\nhtml.touch-layout .hangar-center,\nhtml.touch-layout .hangar-stats { display: none; }\nhtml.touch-layout .hangar-ships {\n  width: 100%;\n  overflow-x: auto;\n  gap: 9px;\n  padding: 3px 2px 10px;\n  scroll-snap-type: x mandatory;\n}\nhtml.touch-layout .hangar-ships .ship-card {\n  flex: 0 0 min(64vw, 240px);\n  max-width: 240px;\n  scroll-snap-align: center;\n}\nhtml.touch-layout .hangar-right { width: 100%; margin-top: 10px; }\nhtml.touch-layout .hangar-actions {\n  position: sticky;\n  right: auto;\n  bottom: 0;\n  width: 100%;\n  margin-top: 10px;\n  padding: 8px 0 max(6px, env(safe-area-inset-bottom));\n  background: linear-gradient(transparent, rgba(0, 5, 10, 0.94) 28%);\n  z-index: 3;\n}\n\n@media (max-height: 560px) {\n  html.touch-layout .hud-fps,\n  html.touch-layout .hud-kit,\n  html.touch-layout .hud-resources,\n  html.touch-layout .radar-wrap,\n  html.touch-layout .target-preview { display: none !important; }\n  html.touch-layout .hud-score {\n    left: 8px; top: 8px;\n    padding: 7px 10px;\n    transform: scale(0.8);\n    transform-origin: top left;\n  }\n  html.touch-layout .hud-vitals { left: 8px; top: 69px; bottom: auto; width: 145px; }\n  html.touch-layout .hud-drive { left: 163px; top: 69px; bottom: auto; width: 145px; }\n  html.touch-layout .hud-weapons {\n    right: 8px; top: 57px; bottom: auto;\n    width: 174px; padding: 7px 10px;\n  }\n  html.touch-layout .hud-weapons .panel-title { display: none; }\n  html.touch-layout .weapon-name { font-size: 11px; }\n  html.touch-layout .comms-feed {\n    left: 242px; top: 8px; width: min(310px, 38vw);\n  }\n  html.touch-layout .comms-line { padding: 5px 8px; font-size: 10px; }\n  html.touch-layout .interact-prompt {\n    bottom: 174px;\n    max-width: 42vw;\n    padding: 5px 10px;\n    font-size: 10px;\n    letter-spacing: 0.18em;\n  }\n  html.touch-layout .offer-panel { right: 10px; top: 116px; width: 280px; padding: 10px 12px; }\n  html.touch-layout .wave-banner { top: 18%; font-size: 20px; }\n  html.touch-layout .screen { justify-content: flex-start; }\n  html.touch-layout .title { margin-top: 5vh; font-size: clamp(31px, 9vw, 54px); }\n  html.touch-layout .subtitle { margin: 8px 0 20px; font-size: 10px; }\n  html.touch-layout .controls-cols,\n  html.touch-layout .manual-cols { flex-direction: column; gap: 12px; }\n  html.touch-layout .loadout-panel {\n    height: 84vh;\n    flex-direction: row;\n    gap: 12px;\n    overflow: hidden;\n  }\n  html.touch-layout .loadout-left {\n    width: 35%;\n    flex-shrink: 0;\n    overflow-y: auto;\n  }\n  html.touch-layout .loadout-right { min-width: 0; overflow-y: auto; }\n  html.touch-layout .recipe-row { padding: 8px; }\n  html.touch-layout .trade-panel { height: 84vh; width: 94vw; }\n  html.touch-layout .screen.hangar > h2 { min-width: 280px; font-size: 21px; }\n  html.touch-layout .hangar-body { padding-bottom: 4px; }\n  html.touch-layout .hangar-main { display: block; }\n  html.touch-layout .hangar-ships { overflow: visible; padding-bottom: 4px; }\n  html.touch-layout .hangar-ships .ship-card {\n    flex: 1 1 0;\n    max-width: none;\n    padding-bottom: 7px;\n  }\n  html.touch-layout .ship-thumb { height: 70px; }\n  html.touch-layout .hangar-ships .stat-row { display: none; }\n  html.touch-layout .hangar-right {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 6px;\n    margin-top: 4px;\n  }\n  html.touch-layout .hangar-right .ship-detail { display: none; }\n  html.touch-layout .hangar-right > .hangar-subhead { grid-column: 1 / -1; }\n  html.touch-layout .diff-btn {\n    min-height: 54px;\n    padding: 6px 8px;\n    gap: 7px;\n    align-items: center;\n  }\n  html.touch-layout .diff-icon { width: 24px; height: 24px; }\n  html.touch-layout .diff-btn b { margin: 0; font-size: 12px; }\n  html.touch-layout .diff-btn .diff-text > span { display: none; }\n  html.touch-layout .hangar-actions {\n    position: static;\n    margin-top: 7px;\n    padding: 0;\n    background: none;\n  }\n  html.touch-layout .hangar-actions .ns-btn { min-height: 46px; padding-block: 8px; }\n}\n\n@media (orientation: portrait) {\n  .touch-controls { --touch-size: 44px; }\n  .touch-stick { width: 104px; height: 104px; }\n  .touch-stick-knob { width: 44px; height: 44px; }\n  .touch-left-deck,\n  .touch-right-deck {\n    bottom: max(8px, env(safe-area-inset-bottom));\n    width: 104px;\n    height: 158px;\n  }\n  .touch-left-deck { left: max(8px, env(safe-area-inset-left)); }\n  .touch-right-deck { right: max(8px, env(safe-area-inset-right)); }\n  .touch-move-stick,\n  .touch-aim-stick { left: 0; bottom: 0; }\n  .touch-maneuver {\n    position: fixed;\n    left: 50%;\n    top: auto;\n    bottom: max(8px, env(safe-area-inset-bottom));\n    grid-template-columns: repeat(2, 52px);\n    gap: 4px;\n    transform: translateX(-50%);\n  }\n  .touch-maneuver button { min-width: 52px; min-height: 48px; padding: 0 3px; }\n  .touch-boost {\n    left: 0;\n    bottom: 112px;\n    width: 104px;\n    height: 46px;\n  }\n  .touch-actions {\n    position: fixed;\n    left: max(120px, calc(env(safe-area-inset-left) + 120px));\n    right: max(8px, env(safe-area-inset-right));\n    top: auto;\n    bottom: max(120px, calc(env(safe-area-inset-bottom) + 120px));\n    display: flex;\n    gap: 3px;\n    transform: none;\n  }\n  .touch-actions button,\n  .touch-fire,\n  .touch-seeker,\n  .touch-actions [data-touch-action='weapon'],\n  .touch-actions [data-touch-action='interact'],\n  .touch-actions [data-touch-action='decline'] {\n    position: static;\n    flex: 1 1 0;\n    width: auto;\n    min-width: 44px;\n    height: 46px;\n    min-height: 46px;\n    padding: 0 2px;\n    border-radius: 0;\n    clip-path: polygon(7px 0, 100% 0, 100% calc(100% - 7px), calc(100% - 7px) 100%, 0 100%, 0 7px) !important;\n  }\n  .touch-system-tray {\n    left: 50%;\n    bottom: max(172px, calc(env(safe-area-inset-bottom) + 172px));\n    transform: translateX(-50%);\n  }\n  .touch-system-tray button { width: 48px; }\n  .touch-utility {\n    left: 50%;\n    right: auto;\n    top: auto;\n    bottom: max(224px, calc(env(safe-area-inset-bottom) + 224px));\n    transform: translateX(-50%);\n  }\n  .touch-utility button { width: 56px; padding: 0 3px; }\n\n  html.touch-layout .hud-vitals,\n  html.touch-layout .hud-drive,\n  html.touch-layout .hud-kit,\n  html.touch-layout .hud-resources,\n  html.touch-layout .hud-fps,\n  html.touch-layout .target-preview,\n  html.touch-layout .comms-feed { display: none !important; }\n  html.touch-layout .hud-score {\n    left: max(7px, env(safe-area-inset-left));\n    top: max(7px, env(safe-area-inset-top));\n    max-width: 225px;\n    padding: 6px 9px;\n  }\n  html.touch-layout .hud-score .score-line {\n    overflow: hidden;\n    font-size: 9px;\n    letter-spacing: 0.18em;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  html.touch-layout .hud-score .quest-tracker { display: none; }\n  html.touch-layout .hud-weapons {\n    right: max(7px, env(safe-area-inset-right));\n    top: max(65px, calc(env(safe-area-inset-top) + 65px));\n    bottom: auto;\n    width: 138px;\n    padding: 6px 8px;\n  }\n  html.touch-layout .hud-weapons .panel-title { display: none; }\n  html.touch-layout .weapon-name { font-size: 10px; letter-spacing: 0.18em; }\n  html.touch-layout .weapon-row { gap: 6px; margin: 4px 0; }\n  html.touch-layout .weapon-slot { width: 23px; height: 18px; line-height: 18px; }\n  html.touch-layout .missile-status { font-size: 8px; letter-spacing: 0.15em; }\n  html.touch-layout .radar-wrap {\n    left: max(7px, env(safe-area-inset-left));\n    right: auto;\n    top: max(65px, calc(env(safe-area-inset-top) + 65px));\n    bottom: auto;\n    width: 82px;\n    height: 82px;\n    opacity: 0.72;\n  }\n  html.touch-layout .radar-wrap .radar-canvas {\n    width: 100% !important;\n    height: 100% !important;\n  }\n  html.touch-layout .interact-prompt { bottom: 286px; max-width: 72vw; }\n\n  html.touch-layout .screen.hangar {\n    display: block;\n    height: 100%;\n    overflow-y: scroll;\n    padding-bottom: max(18px, env(safe-area-inset-bottom));\n  }\n  html.touch-layout .screen.hangar > h2 { min-width: 0; width: 100%; }\n  html.touch-layout .hangar-body { padding-bottom: 16px; }\n  html.touch-layout .hangar-actions {\n    position: static;\n    margin-top: 14px;\n    padding: 0 0 max(10px, env(safe-area-inset-bottom));\n    background: none;\n  }\n  html.touch-layout .loadout-panel {\n    height: auto;\n    flex-direction: column;\n    gap: 12px;\n    overflow-y: auto;\n  }\n  html.touch-layout .loadout-left { width: 100%; overflow: visible; }\n  html.touch-layout .loadout-right { overflow: visible; }\n}\n\n@media (orientation: portrait) and (max-width: 340px) {\n  .touch-actions {\n    bottom: max(120px, calc(env(safe-area-inset-bottom) + 120px));\n    display: grid;\n    grid-template-columns: repeat(3, minmax(44px, 1fr));\n  }\n  .touch-system-tray { bottom: max(220px, calc(env(safe-area-inset-bottom) + 220px)); }\n  .touch-utility { bottom: max(272px, calc(env(safe-area-inset-bottom) + 272px)); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
